import React, { useState } from "react";
import FormField from "../Common/FormField";
import { useTranslation } from "react-i18next";
import { COMPANYINFO_VALIDATION_FIELDS, REGEX } from "../Common/constants";

const CompanyInfoSection = ({ submit, updateSavobj, user }) => {
  const { t } = useTranslation("common");
  const {
    bussRegName,
    bussRegAddress,
    bussRegPostcode,
    bussRegCity,
    bussRegCountry,
    organisationNumber
  } = user;

  const [companyErrors, setCompanyErrors] = useState({
    bussRegName: false,
    bussRegAddress: false,
    bussRegPostcode: false,
    bussRegCity: false,
    bussRegCountry: false,
    organisationNumber: false,
  });

  const getCountrySpecificValidationRules = () => {
    const validationRulesByCountry = {
      [t("access.SWEDEN")]: {
        organisationNumber: REGEX.NUMBER_HYPHEN,
      },
    };

    return validationRulesByCountry[user.country] || {};
  };

  const getValidationRule = (field) => {
    const countrySpecificValidationRules = getCountrySpecificValidationRules();
    return countrySpecificValidationRules[field] || COMPANYINFO_VALIDATION_FIELDS[field];
  };

  const handleChange = (field, value) => {
    const validationRule = getValidationRule(field);
    const isError = !value.match(validationRule);
    setCompanyErrors((prev) => ({ ...prev, [field]: isError }));
    updateSavobj(field, value);
  };

  return (
    <section id="company-info">
      <div className="row">
        <div className="col-xs-12">
          <h4 className="heading-4 dls-deep-blue pad-2-t pad-2-b">
            {t("newUserUK.companyInfoHeading")}
          </h4>
        </div>
        <FormField
          id="bussRegName"
          name="bussRegName"
          label={t("deleteUser.bussregname")}
          colmd="col-md-4"
          value={bussRegName}
          onBlur={(event) => { handleChange("bussRegName", event.target.value) }}
          onChange={(event) => { handleChange("bussRegName", event.target.value) }}
          error={companyErrors.bussRegName ? t("deleteUser.bussregnameerror") : submit && !bussRegName && t("deleteUser.bussregnamerequired")}
        />
        <FormField
          id="bussRegAddress"
          name="bussRegAddress"
          label={t("deleteUser.bussregaddress")}
          colmd="col-md-4"
          value={bussRegAddress}
          onBlur={(event) => { handleChange("bussRegAddress", event.target.value) }}
          onChange={(event) => { handleChange("bussRegAddress", event.target.value) }}
          error={companyErrors.bussRegAddress ? t("deleteUser.bussregaddresserror") : submit && !bussRegAddress && t("deleteUser.bussregaddressrequired")}
        />
        <FormField
          id="bussRegPostcode"
          name="bussRegPostcode"
          label={t("deleteUser.bussregpostcode")}
          colmd="col-md-4"
          value={bussRegPostcode}
          onBlur={(event) => { handleChange("bussRegPostcode", event.target.value) }}
          onChange={(event) => { handleChange("bussRegPostcode", event.target.value) }}
          error={companyErrors.bussRegPostcode ? t("deleteUser.bussregpostcodeerror") : submit && !bussRegPostcode && t("deleteUser.bussregpostcoderequired")}
        />
        <FormField
          id="bussRegCity"
          name="bussRegCity"
          label={t("deleteUser.bussregcity")}
          colmd="col-md-4"
          value={bussRegCity}
          onBlur={(event) => { handleChange("bussRegCity", event.target.value) }}
          onChange={(event) => { handleChange("bussRegCity", event.target.value) }}
          error={companyErrors.bussRegCity ? t("deleteUser.bussregcityerror") : submit && !bussRegCity && t("deleteUser.bussregcityrequired")}
        />
        <FormField
          id="bussRegCountry"
          name="bussRegCountry"
          label={t("deleteUser.bussregcountry")}
          colmd="col-md-4"
          value={bussRegCountry}
          onBlur={(event) => { handleChange("bussRegCountry", event.target.value) }}
          onChange={(event) => { handleChange("bussRegCountry", event.target.value) }}
          error={companyErrors.bussRegCountry ? t("deleteUser.bussregcountryerror") : submit && !bussRegCountry && t("deleteUser.bussregcountryrequired")}
        />
        <FormField
          id="organisationNumber"
          name="organisationNumber"
          label={t("deleteUser.organisationnumber")}
          colmd="col-md-4"
          value={organisationNumber}
          onBlur={(event) => { handleChange("organisationNumber", event.target.value) }}
          onChange={(event) => { handleChange("organisationNumber", event.target.value) }}
          error={companyErrors.organisationNumber ? t("deleteUser.organisationnumbererror") : submit && !organisationNumber && t("deleteUser.organisationnumberrequired")}
        />
      </div>
    </section>
  );
};

export default CompanyInfoSection;
